<template>
    <section>
        <div class="public-gallery">
            <div class="swiper-container" :id="galleryId">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="image in imageUrls">
                        <picture class="public-gallery-image">
                            <source media="(min-width: 1920px" :srcset="getCropUrl(image, 2560, 1440)" />
                            <source media="(min-width: 1680px" :srcset="getCropUrl(image, 1920, 1080)" />
                            <source media="(min-width: 1080px" :srcset="getCropUrl(image, 1680, 945)" />
                            <source media="(min-width: 720px" :srcset="getCropUrl(image, 1080, 608)" />
                            <source media="(min-width: 320px" :srcset="getCropUrl(image, 720, 405)" />
                            <source media="(min-width: 0px" :srcset="getCropUrl(image, 480, 270)" />
                            <img :src="getCropUrl(image, 2560, 1440)" />
                        </picture>
                    </div>
                </div>

                <div class="swiper-pagination"></div>

                <div class="swiper-button-prev">
                    <svg width="40" height="40">
                        <use href="/ui/icons/custom-sprite.svg#feather-chevron-left" />
                    </svg>
                </div>
                <div class="swiper-button-next">
                    <svg width="40" height="40">
                        <use href="/ui/icons/custom-sprite.svg#feather-chevron-right" />
                    </svg>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    // Swiper v11 import syntax
    import { Swiper } from "swiper";
    import { Navigation } from "swiper/modules";
    import { Pagination } from "swiper/modules";
    import { Autoplay } from "swiper/modules";
    import "swiper/css";
    import "swiper/css/navigation";
    import "swiper/css/pagination";

    export default {
        name: 'gallery',
        props: {
            imageUrls: {
                type: Array,
                default: undefined
            }
        },
        data() {
            return {
                swiper: undefined,
                galleryId: this.setId()
            }
        },
        mounted() {
            this.swiper = new Swiper("#" + this.galleryId, {
                modules: [Navigation, Pagination, Autoplay],
                autoplay: {
                    delay: 3000,
                },

                preloadImages: false,

                lazy: {
                    loadPrevNext: true,
                },

                loop: true,

                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },

                pagination: {
                    el: '.swiper-pagination',
                },
            });
        },
        methods: {
            setId: function () {
                return `gallery-${this.createUUID()}`;
            },
            createUUID: function () {
                return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                    return v.toString(16);
                });
            },
            getCropUrl: function (url, width, height) {
                return `${url}?width=${width}&height=${height}&quality=90`;
            }
        }
    }
</script>